import React from 'react'
import styled from 'styled-components'
import { Box, Button, Link, Text } from 'pcln-design-system'
import { WebPBackgroundImage } from '@pcln/content-tile'
import analytics from '../../../utils/analytics'
import RoadtripMobileSrc from '../../../assets/images/promos/road-trip-mobile.jpg'
import RoadtripMobileWebpSrc from '../../../assets/images/promos/road-trip-mobile.webp'

const handleClick = (event: MouseEvent) => {
  event.preventDefault()
  analytics.fireEvent({
    category: 'PCLN_HOME',
    action: 'Click',
    label: 'Roadtrip Promo'
  })
  window.location.assign('/trips')
}

const StyledLink = styled(Link)`
  &:hover {
    text-decoration: none;
  }
`

const Wrapper = styled(WebPBackgroundImage)`
  border-radius: 4px;
`

const StyledText = styled(Text)`
  width: 174px;
`

export default function MobileRoadTripPromo(props: any) {
  return (
    <Box mt={24}>
      <StyledLink mt={24} onClick={handleClick} target="_self" {...props}>
        <Wrapper
          height="136px"
          width={1}
          image={RoadtripMobileSrc}
          imageWebP={RoadtripMobileWebpSrc}
        >
          <Box py={3} pl={3}>
            <StyledText bold fontSize={2} lineHeight={1.4} color="text">
              Planning a roadtrip or local getaway?
            </StyledText>
          </Box>
          <Box pl={3}>
            <Button
              size="small"
              width="106px"
              aria-label="Roadtrip Promo button"
              role="button"
            >
              Search Deals
            </Button>
          </Box>
        </Wrapper>
      </StyledLink>
    </Box>
  )
}
